import React, { PureComponent } from 'react';
import Sparkline from '../../components/MetricsPage/Sparkline';
import { BASE_URL } from '../../config';

const stats = [
  {
    statGroup: 'cssStats',
    stat: 'size',
    suffix: ' b',
  },
  {
    statGroup: 'cssStats',
    stat: 'averageSelectorSpecificity',
  },
  {
    statGroup: 'jsStats',
    stat: 'size',
    suffix: ' b',
  },
];

export default class MetricsRow extends PureComponent {
  static propTypes = {
    // TODO
  }

  render() {
    const { component } = this.props;

    return (
      <div className="row table-row">
        <div className="col-3">
          <a href={`${BASE_URL}/${component.name}/latest/index.html`}>{component.name}</a><br />
        </div>
        {
          stats.map(stat => (
            <div key={`${stat.statGroup}${stat.stat}`}>
              <div className="col-1">
                {component[stat.statGroup][stat.stat] || 0}
                {stat.suffix}
                &nbsp;
              </div>
              <div className="col-1">
                <Sparkline
                  reverse
                  values={component[stat.statGroup].sparkline[stat.stat]}
                />
              </div>
            </div>
          ))
        }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/MetricsPage/MetricsRow.jsx